import React from 'react';

import { UiTypography } from '@/components/ui/Typography';

import { SettingUpProfileAnimationStyles } from './Animation.styles';

export const SettingUpProfileAnimation: React.FC<{
  onFinish: () => void;
}> = ({ onFinish }) => {
  const [progress, setProgress] = React.useState<{
    processing: number;
    initializing: number;
    creating: number;
  }>({ processing: 0, initializing: 0, creating: 0 });

  const animation = () => {
    let timeout;
    const timeOutTime = 3;
    if (Math.round(progress.processing) !== 100) {
      timeout = setTimeout(() => {
        setProgress({ ...progress, processing: progress.processing + 0.1 });
      }, timeOutTime);
    } else if (
      Math.round(progress.processing) === 100 &&
      Math.round(progress.initializing) !== 100
    ) {
      timeout = setTimeout(() => {
        setProgress({ ...progress, initializing: progress.initializing + 0.1 });
      }, timeOutTime);
    } else if (
      Math.round(progress.processing) === 100 &&
      Math.round(progress.initializing) === 100 &&
      Math.round(progress.creating) !== 100
    ) {
      timeout = setTimeout(() => {
        setProgress({ ...progress, creating: progress.creating + 0.1 });
      }, timeOutTime);
    } else {
      clearTimeout(timeout);
      onFinish();
    }
  };

  React.useEffect(() => {
    animation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progress]);

  return (
    <SettingUpProfileAnimationStyles>
      <div className="process">
        <div className="process-data">
          <UiTypography variant="body-medium">
            Processing your request
          </UiTypography>
          <UiTypography variant="body-medium">
            {Math.round(progress.processing)}%
          </UiTypography>
        </div>
        <div className="process-progress">
          <div
            className="process-progress-bar"
            style={{ width: `${progress.processing}%` }}
          />
        </div>
      </div>

      <div className="process">
        <div className="process-data">
          <UiTypography variant="body-medium">
            Initializing AI modules
          </UiTypography>
          <UiTypography variant="body-medium">
            {Math.round(progress.initializing)}%
          </UiTypography>
        </div>
        <div className="process-progress">
          <div
            className="process-progress-bar"
            style={{ width: `${progress.initializing}%` }}
          />
        </div>
      </div>

      <div className="process">
        <div className="process-data">
          <UiTypography variant="body-medium">
            Creating your AI girlfriend
          </UiTypography>
          <UiTypography variant="body-medium">
            {Math.round(progress.creating)}%
          </UiTypography>
        </div>
        <div className="process-progress">
          <div
            className="process-progress-bar"
            style={{ width: `${progress.creating}%` }}
          />
        </div>
      </div>
    </SettingUpProfileAnimationStyles>
  );
};
